import { useState } from "react";
import React from 'react';
import TextField from "./TextField"
import axios from "axios";
import { useAuth } from "../authContext";
import { useNavigate, useLocation } from "react-router-dom";
import Cookies from 'js-cookie';
import styles from '../styles/LoginForm.module.css'


export default function LoginForm() {

    const { setTokens } = useAuth();
    const navigate = useNavigate();
    const location = useLocation();

    const [email, setEmail] = useState('')
    const [password, setPassword] = useState('')
    // Mensaje que deja /mfa cuando la sesion del challenge expiro.
    const [error, setError] = useState(location.state?.message || null);
    const [loading, setLoading] = useState(false);  // Loading state

    async function handleSubmit() {
        // start loading
        setLoading(true);
        setError(null);
        try {
            const response = await axios.post(
                process.env.REACT_APP_BACKEND_HOST + "/auth/login",
                {
                    email,
                    password,
                }
            );
            if (response.data.challengeName && response.data.challengeName === 'NEW_PASSWORD_REQUIRED') {
                // navegar a vista cambiar contraseña
                Cookies.set('session', response.data.session);
                navigate('/change-password?email=' + email);
            } else if (response.data.challengeName === 'EMAIL_OTP') {
                // Cognito ya mandó el código por correo. La session viaja por el
                // state de la ruta y no por cookie: es una credencial temporal.
                navigate('/mfa', {
                    state: {
                        session: response.data.session,
                        email,
                        destination: response.data.challengeParameters?.CODE_DELIVERY_DESTINATION,
                    },
                });
            } else {
                // iniciar sesión y navegar a dashboard
                setTokens(response.data);
                navigate('/');
            }
        } catch (error) {
            // El backend manda un mensaje entendible en cualquier error, no solo
            // en el 401: el bloqueo por intentos llega como 429 y antes se veía
            // como "Request failed with status code 429", que no dice qué hacer.
            setError(
                error.response?.data?.message
                || (error.response?.status === 401
                    ? "Email y/o contraseña inválidos"
                    : "No pudimos iniciar sesión. Inténtalo de nuevo")
            );
        } finally {
            // stop loading
            setLoading(false);
        }
    }
    
    return (
        <div>
            {error && (
                <span className={styles.errorText}>
                    {error}
                </span>
            )}
            <TextField label="Email" type="email" setValue={setEmail} value={email}/>

            <TextField label="Contraseña" type="password" setValue={setPassword} value={password}/>

            <button
                onClick={handleSubmit}
                disabled={loading}
                className={styles.submitBtn}
            >
                {loading? "Loading..." : "Log in"} 
            </button>
        </div>
    )
}